import { useState } from "react";
import {
  Box,
  Dialog,
  DialogHeader,
  DialogPanel,
  DialogPopup,
  DialogTitle,
  Icon,
  Textarea,
} from "@salestrak/ui";

import { useSubmitFeedback } from "#app/lib/hooks/use-submit-feedback";

interface FeedbackDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * "Help us improve" — one Dialog; a sheet on a phone (the responsive Dialog).
 */
export function FeedbackDialog({ open, onOpenChange }: FeedbackDialogProps) {
  const [message, setMessage] = useState("");
  const { submitFeedback, loading: submitting } = useSubmitFeedback();

  function handleClose() {
    setMessage("");
    onOpenChange(false);
  }

  async function handleSubmit() {
    const trimmed = message.trim();
    if (!trimmed) return;
    if (await submitFeedback(trimmed)) handleClose();
  }

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogPopup
        dialogOptions={{
          primary: { label: "Submit", onClick: handleSubmit, disabled: !message.trim(), loading: submitting },
          cancel: { onClick: handleClose, disabled: submitting },
        }}
      >
        <DialogHeader>
          <Box direction="row" align="center" gap="sm">
            <Icon color="primary" name="message" size="sm" />
            <DialogTitle>Help us improve</DialogTitle>
          </Box>
        </DialogHeader>
        <DialogPanel>
          <Textarea
            disabled={submitting}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Tell us what you think — or what is broken."
            rows={4}
            value={message}
          />
        </DialogPanel>
      </DialogPopup>
    </Dialog>
  );
}
